import { otmsHttp } from '@/utils/http/index.js'

/**
 * 自定义导入配置新增
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16135
 */
export function createTemplate(data) {
  return otmsHttp.post('/oms_plus/customer/template/create', data)
}

/**
 * 自定义导入配置编辑
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16141
 */
export function updateTemplate(data) {
	return otmsHttp.post('/oms_plus/customer/template/update', data)
}

/**
 * 自定义导入配置详情
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16143
 */
 export function getTemplateDetail(data) {
	return otmsHttp.post('/oms_plus/customer/template/detail', data)
}

/**
 * 删除自定义导入配置
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16145
 */
 export function deleteTemplate(data) {
	return otmsHttp.post('/oms_plus/customer/template/delete', data)
}

/**
 * 自定义导入配置上传
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16147
 */
 export function uploadTemplate(data) {
	return otmsHttp.post('/customer/template/upload', data)
}


/**
 * 自定义导入配置列表
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16149
 */
 export function getTemplateList(data, params) {
	return otmsHttp.post('/oms_plus/customer/template/page', data, {
    params
  })
}

/**
 * 获取车型列表
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/717
 */
export function getCarType(data) {
	return otmsHttp.post({
		url: '/tcs_plus/car/setting/list',
		method: 'post',
		data,
	})
}
